import IdentTag from "./IdentTag";
export default IdentTag;
